import React from 'react';
import PropTypes from 'prop-types';
import styled from '@emotion/styled';
import ScoreCard from './ScoreCard';
import LinkButton from './LinkButton';
import Commentary from './Commentary';
import summaryContentType from '../proptypes/summary-content';
import ScoreCardSection from './ScoreCardSection';
import { mapping as heroes } from './ScoreCardHeroes';

const Button = styled(LinkButton)`
  font-weight: normal;
  font-size: 0.9rem;
`;

const ScoreCardSvgHero = ({ heroKey }) => {
  const HeroImage = heroes[heroKey];
  return <HeroImage style={{ marginBottom: '20px' }} />;
};
ScoreCardSvgHero.propTypes = {
  heroKey: PropTypes.string.isRequired,
};

const ScoreCardOnlineGame = ({
  children,
  nextGamePath,
  nextGameLink,
  gameTitle,
  gameDescription,
  heroKey,
  summary,
  showCommentary,
  ...restProps
}) => (
  <ScoreCard
    heroOverride={<ScoreCardSvgHero heroKey={heroKey} />}
    gameTitle={gameTitle}
    summary={summary}
    {...restProps}
  >
    {children}
    {(showCommentary || !summary) && (
      <ScoreCardSection bottomBorder={!nextGamePath}>
        <Commentary phrase={gameDescription} emptyState />
      </ScoreCardSection>
    )}
    {nextGamePath && (
      <Button
        className="btn-primary btn-block"
        url={nextGamePath}
        title={nextGameLink}
      />
    )}
  </ScoreCard>
);

ScoreCardOnlineGame.defaultProps = {
  children: null,
  nextGamePath: undefined,
  summary: undefined,
  nextGameLink: 'Play Now',
  showCommentary: false,
};

ScoreCardOnlineGame.propTypes = {
  gameTitle: PropTypes.string.isRequired,
  gameDescription: PropTypes.string.isRequired,
  imageUrl: PropTypes.string.isRequired,
  gameKey: PropTypes.string.isRequired,
  nextGamePath: PropTypes.string,
  nextGameLink: PropTypes.string,
  summary: summaryContentType,
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]),
  heroKey: PropTypes.string.isRequired,
  showCommentary: PropTypes.bool,
};

export default ScoreCardOnlineGame;
